<template>
  <div class="withdraw">
    <div class="withdraw-empty">
      <div class="empty-img"></div>
      <div class="text">暂无可提现金额度</div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'empty'
}
</script>
<style scoped>
  .withdraw-empty{
    width: 100%;
    height: calc(100vh - 2.875rem);
    position: relative;
    background: rgb(248, 249, 251);
    color: rgb(102, 109, 127);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .empty-img{
    width: 14.5625rem;
    height: 9.0625rem;
    background: url('../static/img/empty.png') center no-repeat;;
    background-size: 100% 100%;
    margin-bottom: .625rem;
    position: absolute;
    top: 25%;
  }
  .text{
    font-size: .875rem;
    color: rgb(102, 109, 127);
    position: absolute;
    top: 45%;
  }
</style>



// WEBPACK FOOTER //
// src/components/empty.vue